<ng-container *ngIf="enableMenu$ | async">
  <button mat-icon-button [matMenuTriggerFor]="menu" class="kabob-menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      (click)="downloadOriginalFile()"
      *ngIf="(actions$ | async)?.indexOf('download-original-file') >= 0"
    >
      <mat-icon>archive</mat-icon>
      Download Original CSV
    </button>
    <button
      mat-menu-item
      (click)="downloadSkippedFile()"
      *ngIf="(actions$ | async)?.indexOf('download-skipped-file') >= 0"
    >
      <mat-icon>archive</mat-icon>
      Download Error CSV
    </button>
    <button
      mat-menu-item
      (click)="downloadNAPDataFile()"
      *ngIf="(actions$ | async)?.indexOf('download-nap-data-file') >= 0"
    >
      <mat-icon>archive</mat-icon>
      Account NAP/Product CSV
    </button>
    <button
      mat-menu-item
      (click)="toggleInlineErrors()"
      *ngIf="(actions$ | async)?.indexOf('view-inline-errors') >= 0"
    >
      <span *ngIf="!isErrorShowing; else hideError">View Errors</span>
      <ng-template #hideError>
        <span>Hide Errors</span>
      </ng-template>
    </button>
    <button
      mat-menu-item
      (click)="redirectToBrandReport()"
      *ngIf="(actions$ | async)?.indexOf('view-brand-report') >= 0"
    >
      View Brand Report
    </button>
    <button
      mat-menu-item
      (click)="viewTags()"
      *ngIf="(actions$ | async)?.indexOf('view-tags') >= 0"
    >
      View Tags
    </button>
  </mat-menu>
</ng-container>
